export default __webpack_public_path__ + "static/media/drugs_light.aba61432.jpeg";